import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	presenceOnlineLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	presenceOfflineLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	avatarInputCheckboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputCheckboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	presenceOnlineLabel: {
		id: 'software-filters.filters.assignee.stateless.avatar.presence-online-label',
		defaultMessage: '{name} (online)',
		description: 'The alt text of the avatar for screen reader when the user is online.',
	},
	presenceOfflineLabel: {
		id: 'software-filters.filters.assignee.stateless.avatar.presence-offline-label',
		defaultMessage: '{name} (offline)',
		description: 'The alt text of the avatar for screen reader when the user is offline.',
	},
	avatarInputCheckboxLabel: {
		id: 'software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label',
		defaultMessage: 'assignee filter avatar',
		description: 'label for the avatar button filter by assignee',
	},
	inputCheckboxLabel: {
		id: 'software-filters.filters.assignee.stateless.avatar.input-checkbox-label',
		defaultMessage: 'Filter assignees by {username}',
		description: 'Label for the avatar button filter by assignee',
	},
});
export default messages;
